import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import widgetBg from '../assets/images/Home/HomeBannerWidget.webp';

const HeroWrapper = styled.div`
  position: relative;
  background-size: cover;
  background-position: center;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const MainTitle = styled.h1`
  font-size: 50px;
  font-weight: 300;
  color: white;
  margin-bottom: 0.5rem;
  line-height: 1.2;
  text-align: center;
  text-transform: capitalize;
  white-space: nowrap;
  
  @media (max-width: 992px) {
    font-size: 40px;
  }
  
  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 0.3rem;
    white-space: normal;
  }
`;

const Ampersand = styled.span`
  color: #ff9800;
  margin: 0 0.2rem;
`;

const BrandText = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 300;
  letter-spacing: 1.2rem;
  text-align: center;
  margin-bottom: 4rem;
  text-transform: uppercase;
  
  .white {
    color: white;
  }
  
  .primary {
    color: #ff9800;
  }
  
  @media (max-width: 768px) {
    font-size: 1.7rem;
    margin-bottom: 2rem;
    letter-spacing: 0.8rem;
  }
`;

const InnovationSection = styled.div`
  position: absolute;
  bottom: -120px;
  left: 0;
  right: 0;
  z-index: 10;
  background-image: url(${widgetBg});
  background-size: cover;
  background-position: center;
  padding: 40px 0;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
  
  h2 {
    position: relative;
    z-index: 1;
    font-size: 40px;
    font-weight: 400;
    font-family: 'Montserrat', sans-serif;
    color: white;
    margin-bottom: 1.5rem;
    letter-spacing: 0.6rem;
    text-align: center;
    text-transform: capitalize;
  }
  
  p {
    position: relative;
    z-index: 1;
    color: white;
    font-size: 1.1rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 300;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
    text-align: center;
  }
  
  @media (max-width: 768px) {
    h2 {
      font-size: 32px;
      letter-spacing: 0.4rem;
    }
    
    p {
      font-size: 1rem;
    }
  }
`;

const Hero = ({ backgroundImage, title, subtitle, description }) => {
  // Handle the title to ensure it's displayed in one line
  let formattedTitle = title;
  if (title && title.includes('&')) {
    formattedTitle = title.replace('&', ' & ');
  }

  return (
    <div style={{ position: 'relative', marginBottom: '160px', textAlign: 'center' }}>
      <HeroWrapper style={{ backgroundImage: `url(${backgroundImage})` }}>
        <Container className="text-center d-flex h-100 align-items-center">
          <HeroContent>
            {formattedTitle && (
              <MainTitle>
                {formattedTitle.split('&').length > 1 ? (
                  <>
                    {formattedTitle.split('&')[0]}
                    <Ampersand>&</Ampersand>
                    {formattedTitle.split('&')[1]}
                  </>
                ) : (
                  formattedTitle
                )}
              </MainTitle>
            )}
            
            {subtitle === 'FABXPERT' && (
              <BrandText>
                <span className="white">fab</span>
                <span className="primary">xpert</span>
              </BrandText>
            )}
          </HeroContent>
        </Container>
      </HeroWrapper>
      
      {description && (
        <InnovationSection>
          <Container className="text-center">
            <h2 className="fw-500">Bringing Innovation to Every Cut</h2>
            <p>{description}</p>
          </Container>
        </InnovationSection>
      )}
    </div>
  );
};

export default Hero; 